export const RequiredValidationId = "gadget/validation/required";
export const EmailValidationId = "gadget/validation/email-address";
export const PasswordValidationId = "gadget/validation/password";
export const UrlValidationId = "gadget/validation/url";
export const StringSizeValidationId = "gadget/validation/string-size";
export const NumberRangeValidationId = "gadget/validation/number-range";
export const RegexValidationId = "gadget/validation/regexp";
export const ColorValidationId = "gadget/validation/color";
export const VectorDimensionsValidationId = "gadget/validation/vector-dimensions";
export const UniqueValidationId = "gadget/validation/unique";
export const InvokeCodeValidationId = "gadget/validation/code";
export const FileSizeRangeValidationId = "gadget/validation/file-size-range";
export const ValidImageFileValidationId = "gadget/validation/valid-image-file";
